import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram, Facebook } from "lucide-react";
import { useI18n } from "../contexts/I18nContext";
import { SITE, buildWhatsAppLink, NAV_LINKS_STATIC } from "../data/static";

export const Footer = () => {
  const { t } = useI18n();
  const f = t.footer;

  return (
    <footer data-testid="footer" className="relative bg-[#0F172A] text-slate-300 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-12 pb-12 border-b border-white/10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <span className="w-11 h-11 rounded-full bg-[#D1603D] text-white flex items-center justify-center font-display text-xl font-bold">J</span>
              <div>
                <p className="font-display text-xl font-semibold text-white">{SITE.name}</p>
                <p className="text-xs uppercase tracking-[0.2em] text-[#D1603D]">{SITE.domain}</p>
              </div>
            </div>
            <p className="mt-5 text-sm text-slate-400 leading-relaxed max-w-md">{t.site.description}</p>

            <div className="mt-6 flex gap-3">
              <a href="#" aria-label="Instagram" className="w-10 h-10 rounded-full bg-white/5 hover:bg-[#D1603D] flex items-center justify-center transition-colors">
                <Instagram className="w-4 h-4" />
              </a>
              <a href="#" aria-label="Facebook" className="w-10 h-10 rounded-full bg-white/5 hover:bg-[#D1603D] flex items-center justify-center transition-colors">
                <Facebook className="w-4 h-4" />
              </a>
            </div>
          </div>

          <div className="lg:col-span-3">
            <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#FDE68A] mb-4">{f.explore}</p>
            <ul className="space-y-2.5">
              {NAV_LINKS_STATIC.map((item) => {
                const isRoute = item.href.startsWith("/") && !item.href.includes("#");
                return (
                  <li key={item.key}>
                    {isRoute ? (
                      <Link to={item.href} className="text-sm text-slate-300 hover:text-white transition-colors">
                        {t.nav[item.key]}
                      </Link>
                    ) : (
                      <a href={item.href} className="text-sm text-slate-300 hover:text-white transition-colors">
                        {t.nav[item.key]}
                      </a>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#FDE68A] mb-4">{f.contact}</p>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 text-[#D1603D] mt-0.5" />
                <a href={`tel:+${SITE.whatsappNumber}`} className="hover:text-white">{SITE.phoneDisplay}</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 text-[#D1603D] mt-0.5" />
                <a href={`mailto:${SITE.email}`} className="hover:text-white">{SITE.email}</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-[#D1603D] mt-0.5" />
                <span>{t.site.address}</span>
              </li>
            </ul>

            <a href={buildWhatsAppLink(f.waMsg)} target="_blank" rel="noopener noreferrer"
              className="mt-5 inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#D1603D] text-white text-sm font-semibold hover:bg-[#B34A2B] transition-colors">
              {f.message}
            </a>
          </div>
        </div>

        <div className="pt-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 text-xs text-slate-500">
          <p>© {new Date().getFullYear()} {SITE.name}. {f.rights}</p>
          <p>{f.crafted} · {SITE.domain}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
